import { jsx, Fragment } from "react/jsx-runtime";
import { IconButton } from "../../../Inputs/IconButton/index.js";
import { DotSelected } from "./DotSelected.js";
import { DotUnselected } from "./DotUnselected.js";
const PaginationDots = ({
  carousel,
  contentTypeJoinder,
  contentTypeLabel,
  onButtonAutoplayClick,
  onButtonFocus,
  onButtonBlur,
  scrollSnaps,
  selectedIndex
}) => {
  const [_carouselRef, carouselApi] = carousel;
  const onClick = (index) => {
    (carouselApi == null ? void 0 : carouselApi.scrollTo) && onButtonAutoplayClick(() => carouselApi == null ? void 0 : carouselApi.scrollTo(index));
  };
  if (!scrollSnaps.length) return null;
  return /* @__PURE__ */ jsx(Fragment, { children: scrollSnaps.map((_, index) => /* @__PURE__ */ jsx(
    IconButton,
    {
      "aria-current": index === selectedIndex,
      "aria-label": `${contentTypeLabel} ${index + 1} ${contentTypeJoinder} ${scrollSnaps.length}`,
      onBlur: onButtonBlur,
      onClick: () => onClick(index),
      onFocus: onButtonFocus,
      sx: {
        cursor: "pointer",
        color: "none",
        border: "none",
        padding: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "28px",
        height: "28px"
      },
      children: index === selectedIndex ? /* @__PURE__ */ jsx(DotSelected, {}) : /* @__PURE__ */ jsx(DotUnselected, {})
    },
    index
  )) });
};
export {
  PaginationDots
};
